.mentorSearchContainer {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  margin: var(--space-8) 0;
}

.mentorSearchContainer > :first-child {
  flex: 1;
  min-width: 0;
}

.recommendedButton {
  height: var(--input-height);
  padding: 0 var(--space-4);

  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;

  background: var(--color-surface);
  color: var(--color-text-muted);
  border: none;
  border-radius: var(--button-radius);

  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);

  cursor: pointer;
  transition:
    background-color 0.16s ease,
    border-color 0.16s ease,
    color 0.16s ease;
}

.checkIcon {
  width: 1.5rem;
  height: 1.5rem;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border: 1px solid currentColor;
  border-radius: var(--radius-sm);
}

.checkIcon svg {
  width: 1rem;
  height: 1rem;
  opacity: 0;
}

.recommendedButton:hover {
  color: var(--color-primary);
  border-color: var(--color-focus-border);
  background: var(--color-primary-subtle);
}

.recommendedButtonActive {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.recommendedButtonActive .checkIcon {
  color: var(--color-primary-text);
  background: var(--color-primary);
  border-color: var(--color-primary);
}

.recommendedButtonActive .checkIcon svg {
  opacity: 1;
}

.recommendedButton:focus-visible {
  outline: 3px solid var(--color-focus-ring);
  outline-offset: 2px;
}
